import { LayoutProps } from '../app-schemas/common';
import { CatapotLogo } from '../assets/images';
import GlobalLayout from './GlobalLayout';

const AuthLayout = ({ children, title = '' }: LayoutProps) => (
  <GlobalLayout title={title}>
    <div className="flex dark:bg-neutral-800">
      <div className="w-full lg:w-6/12 px-6">
        <div className="flex gap-2 items-center mt-3">
          <img src={CatapotLogo} className="w-[60px] h-[60px]" alt="catapot" />
          <h2 className="madimi-one font-[400] text-[32px] text-primary-blue-100">catapot</h2>
        </div>

        <div className="w-full max-w-md">{children}</div>
      </div>
    </div>
  </GlobalLayout>
);

export default AuthLayout;
